export function amountToAmountMinor(amount: number) {
  return parseInt((amount * 100).toFixed(0), 10)
}

export function amountMinorToAmount(minor: number) {
  return isFinite(minor) ? parseInt((minor / 100).toFixed(0), 10) : minor
}
